module.exports = "<div class=table-btns-action> <div class=btn ng-click=edit(item) ng-class=\"-1 !== item.__p.indexOf('UPDATE') ? 'btn-info' : 'btn-default'\" ng-if=\"-1 !== item.__p.indexOf('UPDATE')\"> <i ng-class=\"-1 !== item.__p.indexOf('UPDATE') ? 'fa fa-fw fa-pencil-square-o' : 'fa fa-fw fa-eye'\"></i> </div> <div class=\"btn btn-warning\" ng-click=remove(item) ng-if=\"-1 !== item.__p.indexOf('DELETE')\"> <i class=\"fa fa-fw fa-trash-o\"></i> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableButtonGroupActionPerms.html
// module id = 377
// module chunks = 0